export const TOGGLE_SHOW_FILTER = 'TOGGLE_SHOW_FILTER'
export const SET_FILTER = 'SET_FILTER'
export const RESET_STATE = 'RESET_STATE'
